import { css, unsafeCSS } from 'lit';

import token from '../../../utils/get-token';

import { defaultGroupProps } from './group.constants';

export function groupStyles() {
	return css`
		:host {
			--m-group-gap: ${token(defaultGroupProps.gap)};
			--m-group-align: ${unsafeCSS(defaultGroupProps.align)};
			--m-group-justify: ${unsafeCSS(defaultGroupProps.justify)};

			display: flex;
			flex-wrap: wrap;
			gap: var(--m-group-gap);
			align-items: var(--m-group-align);
			justify-content: var(--m-group-justify);
		}
	`;
}
